// extracted by mini-css-extract-plugin
export default {"switch":"LanguageSelector-module__switch___LqcGr"};